/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_VIEWER_ACTION = "APPROVE" | "CREATE" | "EDIT" | "REJECT" | "%future added value";
export type TAG = "ADMIN" | "EXPERT" | "FEATURED" | "MEMBER" | "MODERATOR" | "QUESTION" | "REVIEW" | "STAFF" | "UNANSWERED" | "%future added value";
export type FeaturedCommentContainer_comment = {
    readonly id: string;
    readonly author: {
        readonly id: string;
        readonly username: string | null;
    } | null;
    readonly parent: {
        readonly author: {
            readonly username: string | null;
        } | null;
    } | null;
    readonly tags: ReadonlyArray<{
        readonly code: TAG;
        readonly createdBy: {
            readonly username: string | null;
        } | null;
    }>;
    readonly rating: number | null;
    readonly body: string | null;
    readonly createdAt: string;
    readonly lastViewerAction: COMMENT_VIEWER_ACTION | null;
    readonly replyCount: number;
    readonly " $fragmentRefs": FragmentRefs<"UsernameWithPopoverContainer_comment" | "ReactionButtonContainer_comment" | "MediaSectionContainer_comment" | "UserTagsContainer_comment" | "IgnoredTombstoneOrHideContainer_comment">;
    readonly " $refType": "FeaturedCommentContainer_comment";
};
export type FeaturedCommentContainer_comment$data = FeaturedCommentContainer_comment;
export type FeaturedCommentContainer_comment$key = {
    readonly " $data"?: FeaturedCommentContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"FeaturedCommentContainer_comment">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v1 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
    } as any), v2 = [
        (v1 /*: any*/)
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "FeaturedCommentContainer_comment",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    (v1 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "parent",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": (v2 /*: any*/),
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "Tag",
                "kind": "LinkedField",
                "name": "tags",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "code",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v2 /*: any*/),
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rating",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "body",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "replyCount",
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UsernameWithPopoverContainer_comment"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ReactionButtonContainer_comment"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "MediaSectionContainer_comment"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UserTagsContainer_comment"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "IgnoredTombstoneOrHideContainer_comment"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastViewerAction",
                        "storageKey": null
                    }
                ]
            }
        ],
        "type": "Comment",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '2601708d8f5616518b28afd469efc0fb';
export default node;
